class CompleteTheLookSlider {
  constructor(element) {
    this.container = element
    this.slider = element.querySelector('.pdp-complete-the-look__flex')
    this.prevButton = element.querySelector('.pdp-complete-the-look__arrow--prev')
    this.nextButton = element.querySelector('.pdp-complete-the-look__arrow--next')

    if (!this.slider || !this.prevButton || !this.nextButton) return

    this.init()
  }

  init() {
    // Check if slider is needed (more than 2 items and on mobile)
    this.checkSliderNeed()

    // Add event listeners
    this.prevButton.addEventListener('click', () => this.slide('prev'))
    this.nextButton.addEventListener('click', () => this.slide('next'))
    this.slider.addEventListener('scroll', () => this.updateArrows())

    // Update arrows on resize
    window.addEventListener('resize', () => {
      this.checkSliderNeed()
      this.updateArrows()
    })

    // Initial arrow state
    this.updateArrows()
  }

  checkSliderNeed() {
    const itemCount = this.slider.children.length
    const isMobile = window.innerWidth < 1024 // Adjust breakpoint as needed

    if (itemCount > 2 && isMobile) {
      this.prevButton.style.display = 'flex'
      this.nextButton.style.display = 'flex'
    } else {
      this.prevButton.style.display = 'none'
      this.nextButton.style.display = 'none'
    }
  }

  slide(direction) {
    const scrollAmount = this.slider.offsetWidth * 0.8
    const currentScroll = this.slider.scrollLeft

    if (direction === 'prev') {
      this.slider.scrollLeft = currentScroll - scrollAmount
    } else {
      this.slider.scrollLeft = currentScroll + scrollAmount
    }
  }

  updateArrows() {
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth
    const currentScroll = this.slider.scrollLeft

    // Disable prev button at the start
    this.prevButton.disabled = currentScroll <= 0

    // Disable next button at the end
    this.nextButton.disabled = currentScroll >= maxScroll - 1
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  const completeTheLookElements = document.querySelectorAll('[data-complete-the-look]')
  completeTheLookElements.forEach((element) => {
    new CompleteTheLookSlider(element)
  })
})
